export const setDataLoaded = (isDataLoaded) => {
  return {
    type: 'SET_DATA_LOADED',
    payload: isDataLoaded
  }
}